import { render, staticRenderFns } from "./_task.vue?vue&type=template&id=92f15daa&"
import script from "./_task.vue?vue&type=script&lang=js&"
export * from "./_task.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports